<div class="">
    <div class="modal-header">
        <h4 class="modal-title kx-modal-heading pl-2">
            <strong>{{title}}</strong>
        </h4>
        <span class="kx-modal-close" (click)="hide();"><i class="fa fa-close"></i></span>
    </div>
    <div class="modal-body">
        <ng-container>
            <div>
                <p>{{message}}</p>
            </div>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="hide()">Ok</button>
    </div>
</div>